import { Directive } from '@angular/core';
import { NgxMaskDirective } from 'ngx-mask';

@Directive({
  selector: '[mask]',
  standalone: false,
})
export class MaskDirective extends NgxMaskDirective {}
